module.exports = __webpack_public_path__ + "static/media/publish-video.591ebad6.svg";